import Link from "next/link";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import XIcon from "@mui/icons-material/X";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TelegramIcon from "@mui/icons-material/Telegram";
import config from "@/app.config";

export default function SocialMedia() {
  return (
    <div className="flex items-center gap-x-2">
      <Link
        aria-label="Visit eVerse on Facebook"
        target="_blank"
        href="https://www.facebook.com/eVerseIndia"
      >
        <FacebookIcon color="inherit" fontSize="small" />
      </Link>
      <Link
        aria-label="Visit eVerse on YouTube"
        target="_blank"
        href="https://www.youtube.com/@Everse_Gadgets"
      >
        <YouTubeIcon color="inherit" fontSize="small" />
      </Link>
      <Link
        aria-label="Visit eVerse on Instagram"
        target="_blank"
        href="https://www.instagram.com/everse_in/"
      >
        <InstagramIcon color="inherit" fontSize="small" />
      </Link>
      <Link
        aria-label="Chat with eVerse on WhatsApp"
        target="_blank"
        href={`https://wa.me/+91${config.contact.whatsappNumber}`}
      >
        <WhatsAppIcon color="inherit" fontSize="small" />
      </Link>
      <Link
        aria-label="Visit eVerse on X (Twitter)"
        target="_blank"
        href="https://x.com/everse_in"
      >
        <XIcon color="inherit" fontSize="small" />
      </Link>
      <Link
        aria-label="Visit eVerse on LinkedIn"
        target="_blank"
        href="https://www.linkedin.com/company/everse-in"
      >
        <LinkedInIcon color="inherit" fontSize="small" />
      </Link>
      <Link
        aria-label="Join eVerse on Telegram"
        target="_blank"
        href="https://t.me/@everse_in"
      >
        <TelegramIcon color="inherit" fontSize="small" />
      </Link>
    </div>
  );
}
